import React from "react";
import * as R from "ramda";
import classNames from "classnames";
import style from "./styles.scss";
import { connect } from "react-redux";
import { getters } from "../../model";
// import { isEmptyOrNil } from "utils/General";
import * as PortalSelectors from "redux/modules/portal/selectors";
// import moment from "moment-timezone";
import styles from "../../../View/styles.scss";
import { StatusComponent } from "../../../../Home/Cards/Sessions/Session";
import EditMode from "./EditMode";
import {
  getVisibleSessionFieldIds,
  getIsManageSessionsEnabled
} from "Portal/NewPortal/PortalHome/selectors";
import * as FIELD_IDS from "@sessionboard/sessionboard-value-types/src/constants/standard-module-field-ids";

const decorate = R.compose(
  connect(state => ({
    sessionData: getters.sessionData(state),
    isEditingSession: getters.isEditingSession(state),
    portal: PortalSelectors.portal(state),
    visibleSessionFieldIds: getVisibleSessionFieldIds(state),
    isManageSessionsEnabled: getIsManageSessionsEnabled(state)
  }))
);

const Details = ({ sessionData = {}, isEditingSession = false }) => {
  if (isEditingSession) {
    return <EditMode />;
  }

  const { fields = [], status = "", statusLabel = "" } = sessionData || {};

  return (
    <div className={style.container}>
      <div className={style.innerContainer}>
        {fields.map(field => {
          if (field.id === FIELD_IDS.SESSIONS.STATUS) {
            return (
              <div className={style.row}>
                <div className={style.textBold}>Status:</div>
                <StatusComponent
                  className={styles.statusIndicator}
                  status={status}
                />
                <div className={style.textRegular}>{statusLabel}</div>
              </div>
            );
          }

          if (field.id === FIELD_IDS.SESSIONS.DESCRIPTION) {
            const value = field.editable_value;
            return (
              <div className={style.description}>
                <div className={style.textBold}>{field.name}:</div>
                <div
                  className={classNames(
                    style.textRegular,
                    style.descriptionText
                  )}
                  dangerouslySetInnerHTML={{
                    __html: R.isEmpty(value) || R.isNil(value) ? "-" : value
                  }}
                />
              </div>
            );
          }

          if (field.type === "signature") {
            return (
              <div key={field.id} className={style.row}>
                <div className={style.textBold}>{field.name}:</div>
                <div className={style.textRegular}>
                  {field.plain_value && field.plain_value.length ? (
                    <img src={field.plain_value} height={35} />
                  ) : (
                    "-"
                  )}
                </div>
              </div>
            );
          }

          return (
            <div key={field.id} className={style.row}>
              <div className={style.textBold}>{field.name}:</div>
              <div className={style.textRegular}>
                {field.plain_value && field.plain_value.length
                  ? field.plain_value
                  : "-"}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default decorate(Details);
